import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ViewArticleModal from 'components/modals/ViewArticleModal';
import { Fade } from 'react-reveal';
import { Skeleton } from 'antd';
import { fetchData } from 'utils/fetch';
import { restAPIs } from 'utils/restAPIs';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './styles.scss';

import AllLogo from "assets/images/all.jpg";
import NoResult from "assets/images/no_result.png"

const GeneralArticles = () => {
    const { currentLang } = useSelector((store) => store.commonData);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [list, setArticleList] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingPage, setLoadingPage] = useState(false);
    const [isLastPage, setIsLastPage] = useState(false);
    const [page, setPage] = useState(1);
    const [content, setContent] = useState('');
    const { t } = useTranslation();
    const [categories, setCategories] = useState('')
    const [searchParams] = useSearchParams();
    const [categoryId, setCategoryId] = useState(null)

    


    useEffect(() => {
        window.scrollTo(0, 0);
        
    }, []);

    const handleArticleNavigate = (id) => {
        navigate('/article/' + id);
    };

    const fetchArticles = async (catId) => {
        setCategoryId(catId)
        setIsLoading(true);
        const res = await fetchData(restAPIs.articlesListing(currentLang?.id, 1, null, null, catId));
        setIsLoading(false);

        if (res?.statusCode === 200) {
            setArticleList(res.articles)
            setIsLastPage(res.isLastPage);
        }
    };

    useEffect(() => {
        setCategoryId(searchParams.get('categoryId'))
        fetchArticles(searchParams.get('categoryId'));
        fetchCategories();
    }, [currentLang]);

    const handleOpenViewArticle = (data) => {
        setContent(data);
        setOpen(true);
    };

    const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (windowHeight + scrollTop >= documentHeight - 200 && !isLoadingPage && !isLastPage) {
            fetchPaginateArticles(page + 1); // Load more articles on scroll
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isLoadingPage, isLastPage, page]);

    const fetchPaginateArticles = async (pageToFetch) => {
        setLoadingPage(true);
        const res = await fetchData(restAPIs.articlesListing(currentLang?.id, pageToFetch, null, null, categoryId));
        setLoadingPage(false);

        if (res?.statusCode === 200) {
            setArticleList(prevList => [...prevList, ...res.articles]);
            setIsLastPage(res.isLastPage);
            setPage(pageToFetch);
        }
    };

    const transformDate = (date) => {
        const currentDate = new Date(date);
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        const day = currentDate.getDate();
        const month = currentDate.getMonth(); // Month is zero-based, so add 1
        const year = currentDate.getFullYear();
        const formattedDate = `${day} ${monthNames[month]}, ${year}`;
        return formattedDate;
    };

    const fetchCategories = async () => {
        setIsLoading(true)
        const res = await fetchData(restAPIs.categoryListings(currentLang?.id));
        setCategories(res.category)
        setIsLoading(false);
    }


    return (
        <>
            <div className='container-fluid __articles_list' style={{ paddingTop: '12vh', paddingBottom: '6%' }}>
                <div className='inner'>
                    <div className="c-heading text-center">
                        <div className="c-heading__top">
                            <h2 className="text-default"> </h2>
                        </div>
                        <div className="c-heading__middle">
                            <h3 className="heading-3 text-uppercase"> {t('generalArticles')}</h3>
                        </div>
                        <div className="c-heading__bottom">
                            <div className="c-heading__short-desc" >
                                <span>{t('exploreACuratedCollectionOfInsightfulArticlesCoveringDiverseTopicsAndPerspectives')}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="__filterEnabled block __articles ">
                    <div className="inner">
                        <div className="has-sticker">
                            <Fade bottom duration={800} delay={500}>
                                <ul className="grid-courses grid-courses--one-row">
                                    {
                                        isLoading ?
                                            <>
                                                {[...Array(4)].map((item, idx) => {
                                                    return (
                                                        <li className="grid-academy__item">
                                                            <div className="card-academy">
                                                                <figure className="card-academy__figure">
                                                                    <Skeleton.Button active block style={{ height: '200px' }} />
                                                                </figure>
                                                                <div className="card-academy__info">
                                                                    <div className="card-academy__header">
                                                                        <div className="card-academy__row">
                                                                            <Skeleton active />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>

                                                    )
                                                })}
                                            </>
                                            :
                                            <>
                                                {list?.map((item, idx) => (
                                                    <li className="grid-academy__item" key={idx}>
                                                        <div className="card-academy">
                                                            <figure className="card-academy__figure">
                                                                <a onClick={() => handleArticleNavigate(item?.id)}>
                                                                    <img className="card-academy__media lazy lazy--loaded" src={item?.publicationIcon} alt={item?.name} />
                                                                </a>
                                                            </figure>
                                                            <div className="card-academy__info">
                                                                <div className="card-academy__header">
                                                                    <div className="card-academy__row">
                                                                        <p>{transformDate(item?.creationdate)}</p>
                                                                        <span style={{ color: '#97a51a' }}>{item?.categoryName}</span>
                                                                        <h3 className="card-academy__title">
                                                                            <a onClick={() => handleArticleNavigate(item?.id)}>{item?.name}</a>
                                                                        </h3>
                                                                        <span className="card-academy__desc">{item?.subbody}</span>
                                                                        <a className="__anchor" onClick={() => handleOpenViewArticle(item)}>
                                                                            {t('view_article')}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                                {list?.length == 0 && <div className='__no_result'><img src={NoResult} /> <strong>No Articles found.!</strong> <span>Please change your selection.</span></div>}
                                            </>

                                    }
                                    {isLoadingPage ?
                                        <>
                                            {[...Array(4)].map((item, idx) => {
                                                return (
                                                    <li className="grid-academy__item">
                                                        <div className="card-academy">
                                                            <figure className="card-academy__figure">
                                                                <Skeleton.Button active block style={{ height: '200px' }} />
                                                            </figure>
                                                            <div className="card-academy__info">
                                                                <div className="card-academy__header">
                                                                    <div className="card-academy__row">
                                                                        <Skeleton active />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>

                                                )
                                            })}
                                        </>
                                        : ''
                                    }
                                </ul>
                            </Fade>
                        </div>
                    </div>
                    <div className='__filter_set'>
                        <div className='inner'>
                            <h2 className='__filter_title'>{t('categories')}</h2>
                            <ul>
                                <li className="__filt__item" onClick={() => fetchArticles(null)} key={-1}>
                                    <img loading="lazy" className="imageLoader __filt__media" src={AllLogo} />
                                    <h3 className={categoryId == null ? 'active' : ''}>
                                    {t('all_categories')}
                                    </h3>
                                </li>
                                {categories && categories?.map((item, idx) => {
                                    return (
                                        <li className="__filt__item" onClick={()=>fetchArticles(item?.categoryId)} key={idx}>
                                            <img loading="lazy" className="imageLoader __filt__media" src={item?.coverImage} />
                                            <h3 className={item?.categoryId === categoryId ? 'active' : ''}>
                                                    {item?.name}
                                                </h3>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <ViewArticleModal open={open} onClose={() => setOpen(false)} content={content} />
        </>
    );
};

export default GeneralArticles;
